export default {
  "list.workspace": "我的工作區",
  "list.workspace.li1": "全部內容",
  "list.workspace.li2": "案例",
  "list.workspace.li3": "文檔",
  "list.workspace.li4": "圖像可視化",

  "content.document": "文檔",
  "content.graph": "圖像",
  "content.item": "文件",
  "content.case": "案例",
  "content.data-source": "數據源",
  "content.last-save": "保存於",
  "content.tag": "標簽",
  "content.note": "註釋",

  account: "賬戶",
  "account.account-setting": "賬戶設置",
  "account.lang": "語言",
  "account.contact-us": "聯系我們",
  "account.logout": "退出登錄",

  "edit.view": "視圖",
  "edit.refresh": "刷新",
  "edit.select": "選擇",
  "edit.delete": "删除",
  "edit.selected": "已選擇",
  "edit.moveout": "移出",
  "edit.cancel": "取消",
  "edit.download": "下载",
  "edit.moveto": "移动至",

  "action.rename": "重命名",
  "action.delete": "删除",
  "action.moveout": "移出此案例",
  "action.moveto": "移动至案例",
  "action.view-note": "查看注释",
  "action.view-tag": "查看标签",
  "action.create-newcase": "创建案例",

  "list.name": "名稱",
  "list.last-modified": "最近修改時間",
  "list.stock-code": "股票代碼",
  "list.document-issuer": "發布者",
  "list.data-source": "數據源",

  "tag.less": "顯示較少",
  "tag.more": "顯示全部",

  "dialog.confirm": `確認要從工作區中刪除?此操作不可逆.`,
  "dialog.ok": "確認",
  "dialog.cancel": "取消",
  "dialog.delete": "刪除",
  "dialog.newcase": "新案例",
  "dialog.action-confirm": "請確認您的操作",
  "dialog.casename": "案例名稱",
  "dialog.selected-items": "已選擇文件",
  "dialog.rename-case": "重命名",

  loading: "加載中...",

  "toast.success": "操作成功",
  "toast.error": "出錯了",
  "toast.pending": "進行中...",
  "toast.warning": "請等待上壹個進程完成",

  "dialog.tip1": "",
  "dialog.tip2": "*請輸入至多32個字符",
  "dialog.tip3": "*此案例名已存在",

  popover: "文檔包含在以下案例中："
};



//////////////////
// WEBPACK FOOTER
// ./static/lang/cnt.js
// module id = null
// module chunks = 